//https://selection-dot-sae-dev.ue.r.appspot.com/profession/
import HttpClient from "../services/HttpClient";
import { APP_URL, PROFESSION, ERROR_MESSAGE, PROFESSIONAUTOCOMPLETE } from "../constants";

export const getProfessions = (dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL}${PROFESSION}`, headers)
      .then((response) => {
        if (response.data.result) {
          resolve(response);
        }
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const getProfessionAutocomplete = (profession) => {
  return new Promise((resolve) => {
    const headers = {"Content-Type": "application/json",};
    HttpClient.get(`${APP_URL}${PROFESSIONAUTOCOMPLETE}${profession}`,headers).then((response) => {
      resolve(response);
    }).catch((error) => {
      resolve(error?.response);
    })
  })
}
